export default {"src":"/_next/static/media/picking-fruit.mono.b594c9ff.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};